import { useTranslation } from 'next-i18next'

import { ratingItems } from './StudentSessionRating.const'

export default function SessionRatingItem({
  emoji,
  i18nKey,
  onClick,
  rating,
}: {
  emoji: string
  i18nKey: (typeof ratingItems)[number]['i18nKey']
  onClick: (rating: number) => Promise<void>
  rating: number
}): React.ReactElement {
  const { t } = useTranslation('generics')

  return (
    <button className="space-y-1 flex flex-col items-center" key={rating} onClick={() => onClick(rating)}>
      <span className="text-xs font-medium text-gray-sub-text">{t(i18nKey)}</span>
      <img className="w-10 h-10" key={rating} src={emoji} />
    </button>
  )
}
